import React from 'react';
import PropTypes from 'prop-types';
import styled, { withTheme } from 'styled-components';

import { Text, Media } from '../../../../../components/Boneyard';
import { useTranslations } from './../../../../../graphql/components/TranslationsProvider';

const Tooltip = styled.div`
  z-index: 1;
  position: absolute;
  bottom: ${props => props.tabHeight}px;
  color: ${props => props.textColor};
  border-radius: 8px;
  border: none;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.25);
  width: ${props => props.width}px;
  left: calc(50% - ${props => props.width / 2}px);
  margin-bottom: ${props => props.theme.spacing(2)};
  background-color: ${props => props.backgroundColor};
  padding: ${props => props.theme.spacing(3)}
    ${props =>
      props.tabPosition
        ? props.tabPosition === 'first'
          ? `
        left: 0;
        right: auto;
    `
          : `
    left: auto;
    right:0;
    `
        : ``};
`;

const TabTooltip = ({
  backgroundColor,
  textColor,
  width,
  theme,
  tabPosition,
  tabHeight,
  invalidState,
  id,
  role,
  automationHook,
}) => {
  const translations = useTranslations();

  const errorTranslations = translations.flightsErrors;

  return (
    <Media>
      {mq => {
        return (
          <Tooltip
            role={role}
            id={id}
            p={3}
            backgroundColor={backgroundColor}
            textColor={textColor}
            width={width}
            tabPosition={tabPosition}
            tabHeight={tabHeight}
            data-hook={automationHook}
          >
            <Text size={13} automationHook={invalidState.hook}>
              {errorTranslations[invalidState && invalidState.key] ||
                errorTranslations['errorDefaultMessage']}
            </Text>
          </Tooltip>
        );
      }}
    </Media>
  );
};

TabTooltip.propTypes = {
  theme: PropTypes.object,
  automationHook: PropTypes.string,
  invalidState: PropTypes.object,
  tabPosition: PropTypes.string,
  tabHeight: PropTypes.number,
  backgroundColor: PropTypes.string,
  textColor: PropTypes.string,
  width: PropTypes.number,
  id: PropTypes.string,
  role: PropTypes.string,
};

export default withTheme(TabTooltip);
